module.exports = "/_next/static/images/chest-card-bg-0ca6d131408f4e2f342be883ced68e6d.png";